export class FiltroAgente {
    codAsesor: String;
    loginAsesor: String;
    perfil: String;

    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/models/filtro/filtro-agente.ts